import { type ComboboxItem, Input, Select, Skeleton } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import type { ReactNode } from 'react';
import { query } from '../../util/api/query';
import type { DropdownOptionDto } from '../../util/types/DropdownOptionDto';

type FormGenericSelectorProps<T> = {
	form: UseFormReturnType<T, (values: T) => T>;
	property: string;
	apiRoute: string;
	label: string;
	placeholder: string;
	icon: ReactNode;
};

export function FormGenericSelector<T>({
	form,
	property,
	apiRoute,
	label,
	placeholder,
	icon,
}: FormGenericSelectorProps<T>) {
	const selectorQuery = query<DropdownOptionDto[]>(apiRoute);

	return (
		<>
			{!selectorQuery.isLoading ? (
				<Select
					label={label}
					placeholder={placeholder}
					data={selectorQuery.data?.value.flatMap((p) => {
						const comboBoxItem: ComboboxItem = {
							label: p.name,
							value: p.id.toString(),
						};

						return comboBoxItem;
					})}
					searchable
					clearable
					key={form.key(property)}
					{...form.getInputProps(property)}
					data-cy={`${property}-input`}
					leftSection={icon}
				/>
			) : (
				<Input.Wrapper label={label}>
					<Skeleton height={8} mt={6} width="100%" radius={'xl'} h={25} />
				</Input.Wrapper>
			)}
		</>
	);
}
